<template>
  <div class="monitor-dict-page">
    <particle-background />
    
    <!-- Tab 切换和内容区域 -->
    <div class="content-wrapper">
      <div class="tab-header">
        <div class="tab-container">
          <div 
            v-for="tab in tabs" 
            :key="tab.key"
            :class="['tab-item', { active: activeTab === tab.key }]"
            @click="handleTabChange(tab.key)"
          >
            <Icon :type="tab.icon" />
            <span class="tab-label">{{ tab.label }}</span>
            <span class="tab-count" v-if="tab.count !== null">{{ tab.count }}</span>
          </div>
        </div>
      </div>
      
      <div class="tab-content">
        <!-- 设备字典 -->
        <device-dict v-show="activeTab === 'device'" @count-change="updateCount('device', $event)" />
        
        <!-- 错误码字典 -->
        <error-code-dict v-show="activeTab === 'errorCode'" @count-change="updateCount('errorCode', $event)" />
        
        <!-- 参数字典 -->
        <param-dict v-show="activeTab === 'param'" @count-change="updateCount('param', $event)" />
      </div>
    </div>
  </div>
</template>

<script>
import ParticleBackground from '@/components/ParticleBackground/index.vue'
import DeviceDict from './module/DeviceDict.vue'
import ErrorCodeDict from './module/ErrorCodeDict.vue'
import ParamDict from './module/ParamDict.vue'

export default {
  name: 'MonitorDict',
  components: {
    ParticleBackground,
    DeviceDict,
    ErrorCodeDict,
    ParamDict
  },
  data() {
    return {
      activeTab: 'device',
      tabs: [
        { key: 'device', label: '设备字典', icon: 'md-cube', count: null },
        { key: 'errorCode', label: '错误码字典', icon: 'md-alert', count: null },
        { key: 'param', label: '参数字典', icon: 'md-list', count: null }
      ]
    }
  },
  methods: {
    handleTabChange(tab) {
      this.activeTab = tab
    },
    updateCount(tabKey, count) {
      const tab = this.tabs.find(t => t.key === tabKey)
      if (tab) {
        tab.count = count
      }
    }
  }
}
</script>

<style lang="less" scoped>
.monitor-dict-page {
  width: 100%;
  height: 100%;
  background: transparent;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}

.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  background: linear-gradient(135deg, rgba(0, 21, 41, 0.8), rgba(0, 40, 80, 0.6));
  border: 2px solid rgba(0, 240, 255, 0.3);
  border-radius: 16px;
  overflow: hidden;
  backdrop-filter: blur(10px);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.4);
  position: relative;
  z-index: 2;
}

.tab-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: rgba(0, 20, 40, 0.6);
  border-bottom: 2px solid rgba(0, 240, 255, 0.3);
  padding: 0 20px;
  
  .refresh-btn {
    background: linear-gradient(135deg, rgba(0, 240, 255, 0.2), rgba(0, 180, 255, 0.3));
    border: 1px solid rgba(0, 240, 255, 0.5);
    color: #00f0ff;
    font-weight: 600;
    height: 32px;
    padding: 0 16px;
    border-radius: 6px;
    transition: all 0.3s ease;
    flex-shrink: 0;
    margin-left: 15px;
    
    i {
      font-size: 16px;
    }
    
    &:hover {
      background: linear-gradient(135deg, rgba(0, 240, 255, 0.3), rgba(0, 180, 255, 0.4));
      border-color: #00f0ff;
      box-shadow: 0 0 12px rgba(0, 240, 255, 0.4);
      transform: translateY(-1px);
    }
  }
}

.tab-container {
  display: flex;
  flex: 1;
  
  .tab-item {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    padding: 20px 30px;
    cursor: pointer;
    position: relative;
    transition: all 0.3s ease;
    color: rgba(255, 255, 255, 0.6);
    
    i {
      font-size: 24px;
      transition: all 0.3s ease;
    }
    
    .tab-label {
      font-size: 16px;
      font-weight: 600;
      letter-spacing: 1px;
    }
    
    .tab-count {
      background: rgba(0, 240, 255, 0.2);
      border: 1px solid rgba(0, 240, 255, 0.5);
      padding: 2px 10px;
      border-radius: 12px;
      font-size: 12px;
      font-weight: 700;
      min-width: 30px;
      text-align: center;
    }
    
    &::after {
      content: '';
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%) scaleX(0);
      width: 80%;
      height: 3px;
      background: linear-gradient(90deg, transparent, #00f0ff, transparent);
      box-shadow: 0 0 10px rgba(0, 240, 255, 0.8);
      transition: transform 0.3s ease;
    }
    
    &:hover {
      color: rgba(255, 255, 255, 0.9);
      background: rgba(0, 240, 255, 0.05);
      
      i {
        color: #00f0ff;
        filter: drop-shadow(0 0 5px rgba(0, 240, 255, 0.6));
      }
    }
    
    &.active {
      color: #00f0ff;
      background: rgba(0, 240, 255, 0.1);
      
      i {
        color: #00f0ff;
        filter: drop-shadow(0 0 8px rgba(0, 240, 255, 0.8));
        transform: scale(1.1);
      }
      
      .tab-count {
        background: rgba(0, 240, 255, 0.3);
        border-color: #00f0ff;
        color: #00f0ff;
        box-shadow: 0 0 10px rgba(0, 240, 255, 0.4);
      }
      
      &::after {
        transform: translateX(-50%) scaleX(1);
      }
    }
  }
}

.tab-content {
  flex: 1;
  overflow: hidden;
  padding: 20px;
  display: flex;
  flex-direction: column;
  
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: rgba(0, 20, 40, 0.4);
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: rgba(0, 240, 255, 0.3);
    border-radius: 4px;
    transition: background 0.3s ease;
    
    &:hover {
      background: rgba(0, 240, 255, 0.5);
    }
  }
}
</style>
